module.exports = __webpack_public_path__ + "assets/MemberAnalysis.bc0ae25c.svg";